var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.193,
    height: 31.007,
    viewBox: "0 0 24.193 31.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9ba6ac",
    d: "M48.656,4.712A6.022,6.022,0,0,0,50.4,0a7.864,7.864,0,0,0-4.924,2.236A5.767,5.767,0,0,0,43.7,6.8,6.557,6.557,0,0,0,48.656,4.712Zm3.58,11.942a6.947,6.947,0,0,1,3.207-5.829A6.866,6.866,0,0,0,50.01,7.792c-2.315-.243-4.514,1.4-5.689,1.4s-2.981-1.37-4.9-1.333A7.242,7.242,0,0,0,33.274,11.7c-2.622,4.686-.672,11.628,1.883,15.43,1.249,1.861,2.736,3.948,4.689,3.873,1.885-.076,2.6-1.254,4.87-1.254s2.912,1.254,4.9,1.216c2.025-.038,3.307-1.9,4.546-3.763a17.114,17.114,0,0,0,2.057-4.353A6.745,6.745,0,0,1,52.236,16.654Z",
    transform: "translate(-32.029 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLg);
export default __webpack_public_path__ + "static/media/apple-lg.e332695f.svg";
export { ForwardRef as ReactComponent };